import Vue from 'vue';
import App from './App.vue';
import store from './store';
import * as GmapVue from 'gmap-vue';
import { Mixin } from './mixin.js';

//AIzaSyDT2HFzh9FP8wKwfOXz1Hm-JqGFGkY7kP8
//AIzaSyAOL7I83nOWp1IhkPeom_KYhRnoRDFpAPo
Vue.mixin(Mixin);

Vue.use(GmapVue, {
  load: {
    key: "AIzaSyDg6glPJ0vokT1sH4xa4hMK9oFDgbnB8u8",
    libraries: 'places,geometry',
    region: 'IT',
    language: 'it',
  },
  installComponents: true
});


Vue.config.productionTip = false;

new Vue({
  store,
  render: h => h(App),
}).$mount('#appstorelocator');
